import {emptyValidator, formValidator} from "../../validators";

const optionConfigCreationValidationStatus = {
    keyKey: {
        validators: [emptyValidator()],
        name: "Option Type"
    },
    keyValue1: {
        validators: [emptyValidator()],
        name: "Option Name"
    },
    keyStatus: {
        validators: [emptyValidator()],
        name: "Status",
    },
    keyActive: {
        validators: [emptyValidator()],
        name: "Active",
    },
};

export const optionConfigValidation = (option) => {
    if (!option || typeof option !== "object") {
        return {general: "Invalid form data"};
    }
    return formValidator(option, optionConfigCreationValidationStatus);
};
